import styled from 'styled-components'

// Styled component of Footer component.
export const FooterWrapper = styled.div`
  background: ${({ theme: { footer } }) => footer && footer.background.primary};
  color: ${({ theme: { footer } }) => footer && footer.text.primary};`